import { useState, useCallback } from 'react'
import { connect } from 'react-redux'
import * as types from '../../actions/actionTypes'
import { confirmSMSAction } from '../../actions/smsActions'
import BulletButton from '../babu/BulletButton'
import CodeField from '../babu/CodeField'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'
import useInterval from '../libs/hooks/useInterval'

function ConfirmSMSForm(props) {
  const { confirmError, confirmSMS, phone, sendSMS, sendSMSLocked, isLoading } =
    props
  const [code, setCode] = useState('')

  const confirmCallback = useCallback(
    code => {
      confirmSMS(phone, code)
    },
    [confirmSMS, phone],
  )

  const resendSMSCallback = useCallback(() => {
    if (!sendSMSLocked) {
      setCountdown(60)
      sendSMS(phone)
    }
  }, [phone, sendSMS, sendSMSLocked])

  const [countdown, setCountdown] = useState(60)
  useInterval(() => {
    if (countdown === 0) {
      return countdown
    }
    setCountdown(countdown - 1)
  }, 1000)

  useGA4Pageview('slash_login_all_guest_enter')

  return (
    <div className="max-w-[800px] my-0 mx-auto text-center">
      <CodeField
        containerClassName="mt-xxl mb-m"
        codeLength={6}
        code={code}
        setCode={setCode}
        sendCode={confirmCallback}
        errorMessage={confirmError ? '可能打錯了，再試一次' : ''}
      />
      <BulletButton
        variant="solid"
        className="mt-m"
        type="submit"
        loading={isLoading}
        disabled={sendSMSLocked}
        onClick={resendSMSCallback}>
        {sendSMSLocked ? `00:${countdown} 後可重新發送` : '重新發送'}
      </BulletButton>
      <p
        className="babu-text-paragraph mt-l text-text500 underline cursor-pointer"
        onClick={props.changePhone}>
        換一支手機號碼
      </p>
    </div>
  )
}

export default connect(
  state => ({
    confirmError: state.sms.confirmError,
    sendSMSLocked: state.sms.sendSMSLocked,
  }),
  dispatch => ({
    confirmSMS(phone, code) {
      dispatch(confirmSMSAction(phone, code))
    },
    changePhone() {
      dispatch({ type: types.SEND_SMS_ERROR })
    },
  }),
)(ConfirmSMSForm)
